module.exports = __webpack_public_path__ + "img/Zircly_LogoForDark.c50195cf.svg";